import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
const BannerWrapper = ({ className = '', children }) => (_jsx("div", Object.assign({ className: classnames('relative flex flex-col w-screen md:w-full md:h-auto bg-white md:shadow-md md:mb-6 md:rounded-xl md:py-6 md:px-8', className) }, { children: children })));
BannerWrapper.propType = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired
};
export default BannerWrapper;
